module.exports = __webpack_public_path__ + "static/media/FMB_icon10.1ffe6315.svg";